export default __webpack_public_path__ + "static/media/Download icon.6bf5bc14.svg";